import { createFileRoute } from '@tanstack/react-router';
import { AccountingReportsPage } from '@/features/accounting/reports/components/AccountingReportsPage';

export const Route = createFileRoute('/$commiteeSlug/accounting/reports/')({
  component: AccountingReportsPage,
});
